// removed by extract-text-webpack-plugin


// WEBPACK FOOTER //
// ./node_modules/extract-text-webpack-plugin/dist/"}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-83ad1ca4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/syncOrder/index.vue